
import {Component, Vue, Watch} from "vue-property-decorator";
import {save as songSave} from "../api/songs";
import {ISongJson} from "../../../server/src/modules/shared-interfaces";
import {store} from "../Store";


@Component
export default class SongEdit extends Vue {

    data = store.data;

    created() {
        this.fetch()
    }

    @Watch("$route")
    fetch() {
        if (this.$route.params["id"] === 'new') {
            store.newSong();
        }
        const id: number = parseInt(this.$route.params["id"], 10);
        store.fetchCurrentSong(id);
    }

    submit() {
        if (!this.data.currentSong) {
            return;
        }
        songSave(this.data.currentSong).then((newSong:ISongJson) => {
            this.$router.push({name: 'song', params: {id: newSong.id.toString()}})
        }).catch(reason => {
            store.addError('Error saving: ' + reason, 'songEdit.save')
        });
    }
}
